import { makeStyles } from '@material-ui/core/styles'
import themes from 'themes'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  summaryWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  fontBolded: {
    fontWeight: 600,
  },
  captionText: {
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0',
  },
  lighterText: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  divider: {
    margin: '2rem 0px 0px',
    width: '100%',
  },
  paddedDivider: {
    margin: '1.5rem 0px',
    width: '100%',
  },
  buttonStyles: {
    borderRadius: '50px',
    height: '40px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'none',
    backgroundColor: theme.palette.primary.lightest,
  },
  altButtonStyle: {
    borderRadius: '50px',
    height: '40px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'none',
  },
  details: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  mobileAvatar: {
    border: '2px solid #DBD2C1',
    boxShadow: '0 0 0 7px #FFFFFF, 0px 4px 36px rgba(0, 10, 22, 0.13)',
    width: '3.3rem',
    height: '3.3rem',
  },
  icons: {
    color: theme.palette.secondary.dark,
  },
  attributes: {
    color: theme.palette.grey.dark,
    fontWeight: 600,
  },
  coachCardName: {
    marginLeft: theme.spacing(2),
  },
  seeMoreToggle: {
    color: theme.palette.primary.light,
  },
  summaryDetails: {
    fontWeight: 500,
    color: theme.palette.grey.dark,
    margin: '1rem 0',
  },
  rowWrapped: {
    display: 'flex',
    backgroundColor: '#EEE',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '16px',
    alignItems: 'center',
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    marginRight: '16px',
  },
  buttonScale: {
    maxWidth: '213px',
    maxHeight: '40px',
    width: '100%',
    height: '100%',
    borderRadius: '50px',
    textTransform: 'none',
    padding: '0.5rem 1rem',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: '22px',
    '&:hover': {
      backgroundColor: themes.offeringsRefresh.palette.primary.light,
      color: themes.offeringsRefresh.palette.primary.contrastText,
    },
  },
  buttonOverrideBook: {
    backgroundColor: themes.offeringsRefresh.palette.primary.lightest,
    color: themes.offeringsRefresh.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: themes.offeringsRefresh.palette.primary.light,
    },
  },
  infoWrapped: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px',
  },
}))
